import * as React from 'react';
import { useLogin, useNotify, Notification } from 'react-admin';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import PersonOutline from '@material-ui/icons/PersonOutline';
import LockOutlined from '@material-ui/icons/LockOutlined';
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlined from '@material-ui/icons/VisibilityOffOutlined';
import footballArt from '../assets/login-football-art.svg';

const LoginPage = () => {
  const login = useLogin();
  const notify = useNotify();
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (!username.trim() || !password) {
      notify('Введите логин и пароль', 'warning');
      return;
    }

    setLoading(true);
    try {
      await login({ username: username.trim(), password });
    } catch (error) {
      notify('Не удалось войти. Проверьте логин и пароль.', 'warning');
      setLoading(false);
    }
  };

  return (
    <main className="fs-login-page">
      <section className="fs-login-visual" aria-hidden="true">
        <div className="fs-login-visual__copy">
          <span>FOOTSKILL ADMIN</span>
          <h1>Управляйте игроками, результатами и контентом в одном месте.</h1>
          <p>Панель администратора футбольной платформы.</p>
        </div>
        <img src={footballArt} alt="" />
      </section>

      <section className="fs-login-panel">
        <form className="fs-login-card" onSubmit={submit}>
          <div className="fs-login-brand">
            <div className="fs-login-brand__mark">FS</div>
            <div><strong>FOOTSKILL</strong><span>ADMIN</span></div>
          </div>

          <div className="fs-login-card__heading">
            <span>ПАНЕЛЬ УПРАВЛЕНИЯ</span>
            <h2>Вход в админку</h2>
            <p>Используйте учётную запись администратора.</p>
          </div>

          <TextField
            autoFocus
            fullWidth
            variant="outlined"
            label="Логин"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start"><PersonOutline /></InputAdornment>,
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Пароль"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start"><LockOutlined /></InputAdornment>,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                    onClick={() => setShowPassword((value) => !value)}
                  >
                    {showPassword ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="fs-login-submit"
            disabled={loading}
            fullWidth
          >
            {loading ? 'Вход…' : 'Войти'}
          </Button>
        </form>
      </section>
      <Notification />
    </main>
  );
};

export default LoginPage;
